<template>
  <div>
    <ul
      v-if="children"
      class="sidebar-submenu absolute bg-cl-white w-100 p0"
      :style="styles"
    >
      <li
        v-if="parentSlug"
        class="brdr-bottom-1 brdr-cl-matterhorn bg-cl-primary flex"
      >
        <router-link
          class="px25 py10 cl-dark-blue h5 lh25 no-underline col-xs weight-600 uppercase"
          :to="categoryLink({ url_path: parentPath, slug: parentSlug })"
          data-testid="categoryLink"
        >
          {{ $t('View all') }}
        </router-link>
      </li>
      <li
        class="flex save-area-overlay"
        :key="link.slug"
        v-for="link in children"
      >
        <div
          v-if="isCurrentMenuShowed"
          class="subcategory-item brdr-bottom-1 brdr-cl-matterhorn"
        >
          <sub-btn
            v-if="link.children_count > 0"
            class="bg-cl-transparent brdr-none"
            :id="link.id"
            :name="link.name"
          />
          <router-link
            v-else
            class="px25 lh25 py10 cl-dark-blue no-underline col-xs bg-cl-primary uppercase h5"
            :to="categoryLink(link)"
          >
            {{ link.name }}
          </router-link>
        </div>
        <sub-category
          v-if="link.children_count > 0"
          :category-links="link.children_data"
          :id="link.id"
          :parent-slug="link.slug"
          :parent-path="link.url_path"
        />
      </li>
    </ul>
    <ul
      v-if="myAccountLinks && !hasChildren"
      :class="{'save-area-overlay' : (myAccountLinks && !hasChildren)}"
      class="sidebar-submenu absolute w-100 p0 bg-cl-primary"
      :style="styles"
    >
      <li
        class="brdr-bottom-1 brdr-cl-matterhorn bg-cl-primary flex"
        :key="link.id"
        v-for="link in myAccountLinks"
        @click="notify(link.name)"
      >
        <router-link
          class="px25 py10 cl-black h4 no-underline col-xs"
          :to="localizedRoute(link.url)"
        >
          {{ link.name }}
        </router-link>
      </li>
      <li class="brdr-bottom-1 brdr-cl-matterhorn bg-cl-primary flex">
        <a
          href="#"
          class="px25 py10 cl-black h4 no-underline col-xs"
          @click.prevent="logout"
        >
          {{ $t('Logout') }}
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import SubBtn from './SubBtn.vue'
import i18n from '@vue-storefront/i18n'
import config from 'config'
import { formatCategoryLink } from '@vue-storefront/core/modules/url/helpers'
import groupBy from 'lodash-es/groupBy'

export default {
  name: 'SubCategory',
  components: {
    SubBtn
  },
  props: {
    id: {
      type: [String, Number],
      required: true
    },
    categoryLinks: {
      type: null,
      required: false,
      default: false
    },
    parentSlug: {
      type: String,
      required: false,
      default: ''
    },
    parentPath: {
      type: String,
      required: false,
      default: ''
    },
    myAccountLinks: {
      type: null,
      required: false,
      default: false
    }
  },
  computed: {
    children () {
      if (!config.entities.category.categoriesDynamicPrefetch && (this.categoryLinks && this.categoryLinks.length > 0 && this.categoryLinks[0].name)) { // we're using dynamic prefetching and getting just category.children_data.id from 1.7
        return this.categoryLinks
      } else {
        // hardcode - pokazanie kategorii ubrań w marketplace
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        if (this.id === config.server.categoryIdsMap.marketplaceCategoryId) { this.categoriesMap[config.server.categoryIdsMap.marketplaceCategoryId] = this.categoriesMap[config.server.categoryIdsMap.marketplaceClothesCategoryId] }
        // hardcode end
        return this.categoriesMap[this.id] // return my child categories
      }
    },
    categoriesMap () {
      return groupBy(this.$store.getters['category-next/getMenuCategories'], 'parent_id')
    },
    hasChildren () {
      return this.children && this.children.length
    },
    ...mapState({
      submenu: state => state.ui.submenu,
      path: state => state.ui.submenu.path
    }),
    getSubmenu () {
      return this.submenu
    },
    styles () {
      const pos = this.submenu.path.indexOf(this.id)
      return pos !== -1 ? {
        zIndex: pos + 1
      } : false
    },
    isCurrentMenuShowed () {
      return this.getSubmenu && this.getSubmenu.depth && this.getSubmenu.path[this.getSubmenu.depth - 1] === this.id
    }
  },
  // hardcode - pokazanie kategorii ubrań w marketplace
  mounted () {
    this.$store.dispatch('category-next/fetchMenuCategories', { parent: config.server.categoryIdsMap.marketplaceClothesCategoryId })
  },
  // hardcode end
  methods: {
    async logout () {
      await this.$store.dispatch('user/logout', {})
      this.$router.push(this.localizedRoute('/'))
      this.$store.commit('ui/setSubmenu', { depth: false })
    },
    notify (title) {
      if (title === 'My loyalty card' || title === 'My product reviews') {
        this.$store.dispatch('notification/spawnNotification', {
          type: 'warning',
          message: i18n.t('This feature is not implemented yet! Please take a look at https://github.com/DivanteLtd/vue-storefront/issues for our Roadmap!'),
          action1: { label: i18n.t('OK') }
        })
      }
    },
    categoryLink (category) {
      return formatCategoryLink(category)
    }
  }
}
</script>

<style lang="scss" scoped>
// special case for iphones
.save-area-overlay {
  &:last-child {
    margin-bottom: 80px;
    @media only screen and (min-device-width : 375px) and (max-device-width : 812px)  and (-webkit-device-pixel-ratio : 3) and (orientation : portrait) {
      margin-bottom: 200px;
    }
  }
}
  .sidebar-submenu {
    left: 0;
    top: 0;
    min-height: 100%;
    transform: translateX(-100%);
  }

  .subcategory-item {
    display: flex;
    width: 100%;
  }
</style>
